var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * Maps base doc
 */
import { Property, ChildProperty, Complex, Collection } from '@syncfusion/ej2-base';
import { defaultFont } from './constants';
/**
 * Sets and gets the options for customizing the color and width of the border in treemap.
 */
export class Border extends ChildProperty {
}
__decorate([
    Property('#808080')
], Border.prototype, "color", void 0);
__decorate([
    Property(0)
], Border.prototype, "width", void 0);
/**
 * Sets and gets the margin for the treemap.
 */
export class Margin extends ChildProperty {
}
__decorate([
    Property(10)
], Margin.prototype, "left", void 0);
__decorate([
    Property(10)
], Margin.prototype, "right", void 0);
__decorate([
    Property(10)
], Margin.prototype, "top", void 0);
__decorate([
    Property(10)
], Margin.prototype, "bottom", void 0);
/**
 * Sets and gets the options to customize the style of the text contents in the treemap.
 */
export class Font extends ChildProperty {
}
__decorate([
    Property(null)
], Font.prototype, "size", void 0);
__decorate([
    Property(null)
], Font.prototype, "color", void 0);
__decorate([
    Property(defaultFont)
], Font.prototype, "fontFamily", void 0);
__decorate([
    Property('')
], Font.prototype, "fontWeight", void 0);
__decorate([
    Property('Normal')
], Font.prototype, "fontStyle", void 0);
__decorate([
    Property(1)
], Font.prototype, "opacity", void 0);
/**
 * Sets and gets the options for customizing the title of the treemap.
 */
export class CommonTitleSettings extends ChildProperty {
}
__decorate([
    Property('')
], CommonTitleSettings.prototype, "text", void 0);
__decorate([
    Property('')
], CommonTitleSettings.prototype, "description", void 0);
/**
 * Sets and gets the options for customizing the subtitle of the treemap.
 */
export class SubTitleSettings extends CommonTitleSettings {
}
__decorate([
    Complex({ fontFamily: null, fontWeight: null }, Font)
], SubTitleSettings.prototype, "textStyle", void 0);
__decorate([
    Property('Center')
], SubTitleSettings.prototype, "alignment", void 0);
/**
 * Sets and gets the options for customizing the title of the treemap.
 */
export class TitleSettings extends CommonTitleSettings {
}
__decorate([
    Complex({ fontFamily: null, fontWeight: null }, Font)
], TitleSettings.prototype, "textStyle", void 0);
__decorate([
    Property('Center')
], TitleSettings.prototype, "alignment", void 0);
__decorate([
    Complex({}, SubTitleSettings)
], TitleSettings.prototype, "subtitleSettings", void 0);
/**
 * Sets and gets the options to customize the color-mapping in treemap.
 */
export class ColorMapping extends ChildProperty {
}
__decorate([
    Property(null)
], ColorMapping.prototype, "from", void 0);
__decorate([
    Property(null)
], ColorMapping.prototype, "to", void 0);
__decorate([
    Property(null)
], ColorMapping.prototype, "color", void 0);
__decorate([
    Property(null)
], ColorMapping.prototype, "label", void 0);
__decorate([
    Property(null)
], ColorMapping.prototype, "value", void 0);
__decorate([
    Property(null)
], ColorMapping.prototype, "minOpacity", void 0);
__decorate([
    Property(null)
], ColorMapping.prototype, "maxOpacity", void 0);
__decorate([
    Property(true)
], ColorMapping.prototype, "showLegend", void 0);
/**
 * Sets and gets the options for customizing the legend of the treemap.
 */
export class LegendSettings extends ChildProperty {
}
__decorate([
    Property(false)
], LegendSettings.prototype, "visible", void 0);
__decorate([
    Property('Default')
], LegendSettings.prototype, "mode", void 0);
__decorate([
    Property('transparent')
], LegendSettings.prototype, "background", void 0);
__decorate([
    Property('Circle')
], LegendSettings.prototype, "shape", void 0);
__decorate([
    Property('')
], LegendSettings.prototype, "width", void 0);
__decorate([
    Property('')
], LegendSettings.prototype, "height", void 0);
__decorate([
    Complex({ size: null, fontFamily: null, fontWeight: null }, Font)
], LegendSettings.prototype, "textStyle", void 0);
__decorate([
    Property(null)
], LegendSettings.prototype, "fill", void 0);
__decorate([
    Property(1)
], LegendSettings.prototype, "opacity", void 0);
__decorate([
    Property(15)
], LegendSettings.prototype, "shapeWidth", void 0);
__decorate([
    Property(15)
], LegendSettings.prototype, "shapeHeight", void 0);
__decorate([
    Property(10)
], LegendSettings.prototype, "shapePadding", void 0);
__decorate([
    Property(null)
], LegendSettings.prototype, "imageUrl", void 0);
__decorate([
    Complex({ color: null, width: null }, Border)
], LegendSettings.prototype, "border", void 0);
__decorate([
    Complex({ color: '#000000', width: 0 }, Border)
], LegendSettings.prototype, "shapeBorder", void 0);
__decorate([
    Complex({}, CommonTitleSettings)
], LegendSettings.prototype, "title", void 0);
__decorate([
    Complex({ size: null, fontFamily: null, fontWeight: null }, Font)
], LegendSettings.prototype, "titleStyle", void 0);
__decorate([
    Property('Bottom')
], LegendSettings.prototype, "position", void 0);
__decorate([
    Property('None')
], LegendSettings.prototype, "orientation", void 0);
__decorate([
    Property(false)
], LegendSettings.prototype, "invertedPointer", void 0);
__decorate([
    Property('After')
], LegendSettings.prototype, "labelPosition", void 0);
__decorate([
    Property('None')
], LegendSettings.prototype, "labelDisplayMode", void 0);
__decorate([
    Property('Center')
], LegendSettings.prototype, "alignment", void 0);
__decorate([
    Property({ x: 0, y: 0 })
], LegendSettings.prototype, "location", void 0);
__decorate([
    Property(null)
], LegendSettings.prototype, "showLegendPath", void 0);
__decorate([
    Property(null)
], LegendSettings.prototype, "valuePath", void 0);
__decorate([
    Property(false)
], LegendSettings.prototype, "removeDuplicateLegend", void 0);
/**
 * Sets and gets the settings for drill down to visualize the treemap rendered in the initial state.
 */
export class InitialDrillSettings extends ChildProperty {
}
__decorate([
    Property(null)
], InitialDrillSettings.prototype, "groupIndex", void 0);
__decorate([
    Property(null)
], InitialDrillSettings.prototype, "groupName", void 0);
/**
 * Sets and gets the options for customizing the leaf item of the treemap.
 */
export class LeafItemSettings extends ChildProperty {
}
__decorate([
    Property(null)
], LeafItemSettings.prototype, "fill", void 0);
__decorate([
    Property(false)
], LeafItemSettings.prototype, "autoFill", void 0);
__decorate([
    Complex({}, Border)
], LeafItemSettings.prototype, "border", void 0);
__decorate([
    Property(0)
], LeafItemSettings.prototype, "gap", void 0);
__decorate([
    Property(10)
], LeafItemSettings.prototype, "padding", void 0);
__decorate([
    Property(1)
], LeafItemSettings.prototype, "opacity", void 0);
__decorate([
    Property(true)
], LeafItemSettings.prototype, "showLabels", void 0);
__decorate([
    Property(null)
], LeafItemSettings.prototype, "labelPath", void 0);
__decorate([
    Property(null)
], LeafItemSettings.prototype, "labelFormat", void 0);
__decorate([
    Property('TopLeft')
], LeafItemSettings.prototype, "labelPosition", void 0);
__decorate([
    Complex({ color: null, size: null, fontFamily: null }, Font)
], LeafItemSettings.prototype, "labelStyle", void 0);
__decorate([
    Property(null)
], LeafItemSettings.prototype, "labelTemplate", void 0);
__decorate([
    Property('Center')
], LeafItemSettings.prototype, "templatePosition", void 0);
__decorate([
    Property('Trim')
], LeafItemSettings.prototype, "interSectAction", void 0);
__decorate([
    Collection([], ColorMapping)
], LeafItemSettings.prototype, "colorMapping", void 0);
/**
 * Sets and gets the options for customizing the tooltip of the treemap.
 */
export class TooltipSettings extends ChildProperty {
}
__decorate([
    Property(false)
], TooltipSettings.prototype, "visible", void 0);
__decorate([
    Property('')
], TooltipSettings.prototype, "template", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "format", void 0);
__decorate([
    Property(null)
], TooltipSettings.prototype, "fill", void 0);
__decorate([
    Property(0.75)
], TooltipSettings.prototype, "opacity", void 0);
__decorate([
    Property(['Circle'])
], TooltipSettings.prototype, "markerShapes", void 0);
__decorate([
    Complex({ width: null, color: null }, Border)
], TooltipSettings.prototype, "border", void 0);
__decorate([
    Complex({ fontFamily: null, size: null, fontWeight: null, opacity: null }, Font)
], TooltipSettings.prototype, "textStyle", void 0);
/**
 * Sets and gets the options for customizing the selection of the leaf items in treemap.
 */
export class SelectionSettings extends ChildProperty {
}
__decorate([
    Property(false)
], SelectionSettings.prototype, "enable", void 0);
__decorate([
    Property(null)
], SelectionSettings.prototype, "fill", void 0);
__decorate([
    Property('0.5')
], SelectionSettings.prototype, "opacity", void 0);
__decorate([
    Complex({}, Border)
], SelectionSettings.prototype, "border", void 0);
__decorate([
    Property('Item')
], SelectionSettings.prototype, "mode", void 0);
/**
 * Sets and gets the options for customizing the highlighting of the treemap item,
 * when the mouse hover is performed in it.
 */
export class HighlightSettings extends ChildProperty {
}
__decorate([
    Property(false)
], HighlightSettings.prototype, "enable", void 0);
__decorate([
    Property('#808080')
], HighlightSettings.prototype, "fill", void 0);
__decorate([
    Property('0.5')
], HighlightSettings.prototype, "opacity", void 0);
__decorate([
    Complex({}, Border)
], HighlightSettings.prototype, "border", void 0);
__decorate([
    Property('Item')
], HighlightSettings.prototype, "mode", void 0);
/**
 * Sets and gets the options for customizing the level leaf items of the treemap.
 */
export class LevelSettings extends ChildProperty {
}
__decorate([
    Property(null)
], LevelSettings.prototype, "groupPath", void 0);
__decorate([
    Property(0)
], LevelSettings.prototype, "groupGap", void 0);
__decorate([
    Property(10)
], LevelSettings.prototype, "groupPadding", void 0);
__decorate([
    Complex({}, Border)
], LevelSettings.prototype, "border", void 0);
__decorate([
    Property(null)
], LevelSettings.prototype, "fill", void 0);
__decorate([
    Property(false)
], LevelSettings.prototype, "autoFill", void 0);
__decorate([
    Property(1)
], LevelSettings.prototype, "opacity", void 0);
__decorate([
    Property(true)
], LevelSettings.prototype, "showHeader", void 0);
__decorate([
    Property(20)
], LevelSettings.prototype, "headerHeight", void 0);
__decorate([
    Property(null)
], LevelSettings.prototype, "headerTemplate", void 0);
__decorate([
    Property(null)
], LevelSettings.prototype, "headerFormat", void 0);
__decorate([
    Property('Near')
], LevelSettings.prototype, "headerAlignment", void 0);
__decorate([
    Complex({ color: null, size: '13px', fontFamily: null }, Font)
], LevelSettings.prototype, "headerStyle", void 0);
__decorate([
    Property('TopLeft')
], LevelSettings.prototype, "templatePosition", void 0);
__decorate([
    Collection([], ColorMapping)
], LevelSettings.prototype, "colorMapping", void 0);
